import { render, staticRenderFns } from "./tinkAbout.vue?vue&type=template&id=e17681f6"
import script from "./tinkAbout.vue?vue&type=script&lang=js"
export * from "./tinkAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports